import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input"]

  declare readonly inputTarget: HTMLInputElement;

  fill(event: Event) {
    event.preventDefault();
    const trigger = event.currentTarget as HTMLElement;
    const months = Number(trigger.dataset.months ?? 0);
    const weeks = Number(trigger.dataset.weeks ?? 0);
    const days = Number(trigger.dataset.days ?? 0);
    const d = new Date();
    if (months) d.setMonth(d.getMonth() - months);
    if (weeks || days) d.setDate(d.getDate() - weeks * 7 - days);
    const pad = (n: number) => String(n).padStart(2, "0");
    this.inputTarget.value = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }));
  }
}
